import { render } from "./ArtistPage.vue?vue&type=template&id=6116eb3b"
import script from "./ArtistPage.vue?vue&type=script&lang=js"
export * from "./ArtistPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__